import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { StarterComponent } from '../starter/starter-master/starter.component';
import { HomeComponent } from '../pages/home/home.component';
import { AuthGuard } from '../shared/security/auth.guard';
import { NotFoundComponent } from '../pages/not-found/not-found.component';
import { ReportComponent } from '../pages/report/report.component';
import { LoteComponent } from '../pages/lote/lote.component';


const routes: Routes = [
  {
    path: "login",
    loadChildren: "../pages/login/login.module#LoginModule"
  },
  {
    path: "queryreg",
    loadChildren: "../pages/queryreg/queryreg.module#QueryRegModule"
  },
  {
    path: "lote/:groupid/:token",
    loadChildren: "../pages/lote/lote.module#LoteModule"
  },
  {
    path: "label/:groupid/:prodid",
    loadChildren: "../pages/label/label.module#LabelModule"
  },
  {
    path: "print/:groupid/pcp/:pcpid",
    loadChildren: "../pages/print/pcp/print-page.module#PrintModule"
  },
  {
    path: "",
    component: StarterComponent,
    children: [
      {
        path: "",        
        pathMatch: "full",
        redirectTo: "home"
      },
      {
        path: "home",
        data: { breadcrumb: 'Home' },
        component: HomeComponent
      },
      {
        path: "report/:parent",
        data: { breadcrumb: 'Report' },
        loadChildren: "../pages/report/report.module#ReportModule"
      },
      {
        path: "about",
        data: { breadcrumb: 'About' },
        loadChildren: "../pages/about/about.module#AboutModule",
        canActivate: [AuthGuard]
      },
      {
        path: "users",
        data: { breadcrumb: 'User' },
        loadChildren: "../pages/user/obj.module#UserModule"
      },
      {
        path: "templates",
        data: { breadcrumb: 'Template' },
        loadChildren: "../pages/template/obj.module#TemplateModule"
      },
      {
        path: "customers",
        loadChildren: "../pages/customer/obj.module#CustomerModule",
        canActivate: [AuthGuard]
      },
      {
        path: "supports",
        loadChildren: "../pages/support/obj.module#SupportModule",
        //canActivate: [AuthGuard]
      } ,
      {
        path: "supportcodes",
        loadChildren: "../pages/supportcode/obj.module#SupportCodeModule",
        //canActivate: [AuthGuard]
      },
      {
        path: "supportplans",
        loadChildren: "../pages/supportplan/obj.module#SupportPlanModule"
        //canActivate: [AuthGuard]
      },
      {
        path: "sales",        
        loadChildren: "../pages/sale/obj.module#SalesOrderModule",
        canActivate: [AuthGuard]
      },
      {
        path: "salesprice",
        //data: { breadcrumb: 'Sales' },
        loadChildren: "../pages/salesprice/obj.module#SalesPriceModule"
      },
      {
        path: "supply",
        //data: { breadcrumb: 'Sales' },
        loadChildren: "../pages/supply/obj.module#SupplyModule"
      },
      {
        path: "rulefiscal",
        //data: { breadcrumb: 'Sales' },
        loadChildren: "../pages/rulefiscal/obj.module#RuleFiscalModule"
      },
      {
        path: "freights",
        //data: { breadcrumb: 'Sales' },
        loadChildren: "../pages/freight/obj.module#TabFreightModule"
      },
      {
        path: "logareas",
        loadChildren: "../pages/logarea/obj.module#LogAreaModule"
      },
      {
        path: "logroutes",
        loadChildren: "../pages/logroute/obj.module#LogRouteModule"
      },
      {
        path: "kits",
        loadChildren: "../pages/kit/obj.module#ProductKitModule"
      },
      {
        path: "minutas",
        loadChildren: "../pages/minuta/obj.module#MinutaModule"
      },
      {
        path: "minuta-status",
        loadChildren: "../pages/minuta/status/status.module#StatusModule"
      },
      {
        path: "minutas-fatura",
        loadChildren: "../pages/minutabill/obj.module#MinutaBillModule"
      },
      {
        path: "planning",
        loadChildren: "../pages/loadplan/obj.module#LoadPlanModule"
      },
      {
        path: "employees",
        loadChildren: "../pages/employee/obj.module#EmployeeModule"
      },
      {
        path: "customersbase",
        loadChildren: "../pages/customerbase/obj.module#CustomerBaseModule"
      },
      {
        path: "products",
        loadChildren: "../pages/product/obj.module#ProductModule"
      },
      {
        path: "pcps",
        loadChildren: "../pages/pcp/obj.module#PCPModule"
      },
      {
        path: "pcporders",
        loadChildren: "../pages/pcporder/obj.module#PCPOrderModule"
      },
      {
        path: "drivers",
        loadChildren: "../pages/driver/obj.module#DriverModule"
      },
      {
        path: "vehicles",
        loadChildren: "../pages/vehicle/obj.module#VehicleModule"
      },
      {
        path: "carriers",
        loadChildren: "../pages/carrier/obj.module#CarrierModule"
      },
      {
        path: "targets",
        loadChildren: "../pages/target/obj.module#SalesTargetModule"
      },
      {
        path: "reqlogs",
        loadChildren: "../pages/saledeliveryreq/obj.module#DeliveryReqModule"
      },
      { path: "**", component: NotFoundComponent }
    ]
  },
  { path: "**", component: NotFoundComponent }
]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
